import { navigationData } from "./navigationData";
import "./Navigation.scss";
import { useContext } from "react";
import { APP_EVENTS } from "../../../types/museum/museum";
import { AppContext } from "../../../contexts/AppContext";

export const Navigation = ({ activePortal }: { activePortal: string | null }) => {
  const { app } = useContext(AppContext);

  return (
    <div className="navigation">
      {navigationData.map((item, index) => (
        <div
          key={index + item.id}
          className={`navigation-item ${activePortal === item.id ? 'active' : ''}`}
          onClick={() => {
            if (app) {
              const portalName = item.title.toLowerCase().replace(/\s+/g, '_');
              app.appEventsBus.emit(APP_EVENTS.SET_HALL_ACTIVE_PORTAL, portalName);
            }
          }}
        >
          <div className="navigation-dot"></div>
          <div className="navigation-label">{item.title}</div>
          <div className="navigation-years">{item.years}</div>
        </div>
      ))}
    </div>
  );
};
